export const getErrorMessage = (error) => {
    var _a, _b;
    const data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (!data)
        return (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : '';
    if (typeof data === 'string')
        return data;
    if (typeof data === 'object' && 'message' in data) {
        return String(data.message);
    }
    if (typeof data === 'object' && 'detail' in data) {
        return String(data.detail);
    }
    return '';
};
